<template>
    <div class="how-work-item" ref="howWork">
        <div class="how-work-item__image-container d-md-flex d-none how-work-item__sides">
            <transition name="image" mode="out-in">
                <img :src="stickyImage" :key="`sticky-${stickyImage}`" ref="stickyImage" class="how-work-item__image" />
            </transition>
        </div>
        <div class="how-work-item__sides">
            <div 
                v-for="(item, index) in data" 
                :key="item.key" 
                :ref="item.key"
                class="how-work-item__text-container"
            >
                <div :ref="`item-${item.key}`" class="how-work-item__text-container-content">
                    <div class="how-work-item__title-wrapper d-flex align-items-center">
                        <Icon class="how-work-item__step-icon" icon="ecommerce-landing-step"/>
                        <TitleDescription :title='`${item.title} ${index+1}<span class="d-md-inline d-none" style="font-family: Eina">/3</span>`'/>
                    </div>
                    <div>
                        <TitleDescription :description="item.description" />
                        <!-- <div class="d-md-flex d-none">
                            <div 
                                v-for="(step, stepIndex) in Array(3)"
                                :key="stepIndex"
                                :class="{'active-step': index === stepIndex}"
                                class="how-work-item__text-container-content__pagination" 
                            />
                        </div> -->
                    </div>
                </div>
                <img class="d-md-none d-block how-work-item__image" :src="`/img/${item.image}.png`" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import TitleDescription from '@/components/Ecommerce/TitleDescription'
import Icon from '@/components/Theme/Icon'

export default {
    name: 'HowWorkItem',
    components: {
        TitleDescription,
        Icon
    },
    props: {
        data: {
            type: Array
        }
    },
    data() {
        return {
            stickyImage: `/img/${this.data[0].image}.png`
        }
    },
    computed: {
        ...mapState([
            'user'
        ])
    },
    mounted() {
        if(this.user && !this.$refs.howWork) {
            return
        }
        this.animationStart()
        document.addEventListener('scroll', () => this.resetAnimation())
    },
    destroyed() {
        if(this.user && !this.$refs.howWork) {
            return
        }
        this.animationStart()
        document.removeEventListener('scroll', () => this.resetAnimation())
    },
    methods: {
        isInViewport(element) {
            const rect = Array.isArray(element) ? element[0].getBoundingClientRect() : element.getBoundingClientRect()
            return (
                rect.top >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
            );
        },
        animationStart() {
            if(!this.$refs.howWork) {
                return
            }
            this.$refs.howWork.addEventListener('scroll', () => {
                for(let i = 0; i < this.data.length; i++) {
                    const isin = this.isInViewport(this.$refs[this.data[i].key])
                    if(isin) {
                        this.stickyImage = `/img/${this.data[i].image}.png`
                    }
                }
            })
        },
        resetAnimation() {
            if(!this.$refs.howWork) {
                return
            }
            const isin = this.isInViewport(this.$refs.howWork)
            if(!isin) {
                this.$refs.howWork.scrollTo(0, 0)
                this.stickyImage = `/img/${this.data[0].image}.png` 
            }
        },
    }
}
</script>

<style lang="scss" scoped>
$text_wrapper_width: 320px;

.image-enter-active,
.image-leave-active {
  transition:  all .1s;
}

.image-enter,
.image-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

.how-work-item {
    --title-fontsize: 20px;
    --title-lineheight: 28px;
    --title-margin-bottom: 0;
    --description-fontsize: 18px;
    --description-lineheight: 24px;
    @media (max-width: 768px) {
        --description-fontsize: 16px;
        --description-lineheight: 24px;
    }
    @media (max-width: 576px) {
        --title-fontsize: 18px;
        --title-lineheight: 24px;
    }

    display: flex;
    justify-content: space-between;
    overflow: auto;
    scrollbar-width: none; 
     -ms-overflow-style: none;  /* IE and Edge */
     max-width: 1007px;
     width: 100%;
     margin: 0 auto;

    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        height: auto;
    }
    &__sides {
        width: 50%;
        @media (max-width: 768px) {
            width: 100%;
        }

    }
    &__title-wrapper {
        margin-bottom: 16px;
        @media (max-width: 768px) {
            margin-bottom: 8px;
            justify-content: center;
        }
    }
    
    &__step-icon {
        margin-right: 8px;
    }
    
    &__text-container {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        @media (max-width: 768px) {
            flex-direction: column;
            &:not(:last-child) {
                margin-bottom: 72px;
            }
        }
        &-content {
            width: $text_wrapper_width;
            @media (max-width: 991px) {
                max-width: 270px;
            }
            @media (max-width: 768px) {
                text-align: center;
                margin-bottom: 24px;
                max-width: $text_wrapper_width;
            }
            @media (max-width: 576px) {
                margin-bottom: 24px;
                text-align: center;
                width: 280px;
            }
            &__pagination {
                width: 12px;
                height: 10px;
                background: #A0AEC0;
                border-radius: 4px;
                margin-right: 16px;
                margin-top: 16px;

                &.active-step {
                    background: #727CF5;
                }
            }
        }
    }
    &__image-container {
        min-height: 367px;
        position: sticky;
        top: 0;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        
        @media (max-width: 768px) {
            position: relative;
            min-height: unset;
        }
    }
    &__image {
        max-width: 446px;
        width: 100%;
        @media (max-width: 991px) {
            max-width: 328px;
        }
    }
}
</style>>
